import React from 'react';
import block from 'bem-cn-lite';

const b = block('TabTitle');

export default
({children}) => <div className={b()}>{children}</div>;
